<template>


    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">出库计划</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">出库单号</div>
                    <div class="header-item">流水号</div>
                    <div class="header-item">产品名称</div>
                    <div class="header-item">出库数量</div>


                    <div class="header-item">功能间</div>
                    <div class="header-item">关联任务号</div>
                    <div class="header-item">关联订单号</div>
                    <div class="header-item">出库时间</div>
                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in outboundList" :key="index">
                            <div class="body-item">{{ item.outboundNumber }}</div>
                            <div class="body-item">{{ item.numId }}</div>
                            <div class="body-item">{{ item.productName }}</div>
                            <div class="body-item"> {{ item.operationNum }}{{ item.unit }}</div>

                            <div class="body-item"> {{ item.room }}</div>
                            <div class="body-item"> {{ item.taskNumber }}</div>
                            <div class="body-item"> {{ item.orderNumber }}</div>
                            <div class="body-item"> {{ item.dateTime }}</div>
                        </div>
                        <div class="empty-tip" v-if="outboundList.length === 0">
                            暂无数据
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>


</template>

<script>
// 导入出库计划列表接口
import { getOutboundPlans } from '@/api/OutboundPlan';

export default {

    data() {
        return {
            // 搜索表单数据
            searchForm: {
                outboundNumber: '',
                numId: '',
                productName: '',
                productCode: '',
                roomId: '',
                dateTime: []
            },
            // 功能间映射表（解决ID和名称匹配问题）
            roomMap: {

            },
            // 列表数据
            outboundList: [], // 当前页展示的数据
            allOutboundList: [], // 保存全部数据（用于前端分页）
            total: 0, // 总条数（全部数据的长度）
            currentPage: 1, // 当前页码
            pageSize: 10, // 每页条数
            loading: false, // 加载状态
            // 详情弹窗
            detailVisible: false,
            currentOutbound: null
        };
    },
    mounted() {
        // 页面加载后请求数据，并确保分页组件渲染
        this.fetchOutboundPlans().then(() => {
            this.$nextTick(() => {
                console.log('分页组件渲染状态：', this.$refs.pagination ? '已渲染' : '未渲染');
            });
        });
    },
    methods: {
        /**
         * 手动分页：根据当前页码和页大小截取数据
         */
        handlePagination() {
            // 计算截取起始/结束索引
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            // 截取当前页数据
            this.outboundList = this.allOutboundList.slice(startIndex, endIndex);
            // 强制更新视图，确保数据生效
            this.$forceUpdate();
        },

        /**
         * 前端搜索过滤：基于全部数据过滤（接口不支持搜索时生效）
         */
        filterData() {
            let filteredList = [...this.allOutboundList];
            // 出库单号过滤
            if (this.searchForm.outboundNumber) {
                filteredList = filteredList.filter(item =>
                    item.outboundNumber?.includes(this.searchForm.outboundNumber.trim())
                );
            }
            // 流水号过滤
            if (this.searchForm.numId) {
                filteredList = filteredList.filter(item =>
                    item.numId?.includes(this.searchForm.numId.trim())
                );
            }
            // 产品名称过滤
            if (this.searchForm.productName) {
                filteredList = filteredList.filter(item =>
                    item.productName?.includes(this.searchForm.productName.trim())
                );
            }
            // 功能间过滤（核心修复：兼容ID和名称两种匹配方式）
            if (this.searchForm.roomId) {
                filteredList = filteredList.filter(item => {
                    // 方式1：匹配roomId（兼容数字/字符串）
                    const roomIdMatch = item.roomId != null && item.roomId.toString() === this.searchForm.roomId;
                    // 方式2：匹配room名称（直接通过ID映射名称）
                    const roomNameMatch = item.room === this.roomMap[this.searchForm.roomId];
                    // 满足任一方式即匹配
                    return roomIdMatch || roomNameMatch;
                });
            }
            // 时间范围过滤
            if (this.searchForm.dateTime.length === 2) {
                const [startTime, endTime] = this.searchForm.dateTime;
                filteredList = filteredList.filter(item => {
                    if (!item.dateTime) return false;
                    const itemTime = item.dateTime.split(' ')[0] || '';
                    return itemTime >= startTime && itemTime <= endTime;
                });
            }
            return filteredList;
        },

        /**
         * 调用接口获取全部出库计划数据
         */
        async fetchOutboundPlans() {
            this.loading = true;
            try {
                // 构造请求参数（包含搜索条件）
                const params = {
                    userId: localStorage.getItem('userId') || '',
                    outboundNumber: this.searchForm.outboundNumber.trim(),
                    numId: this.searchForm.numId.trim(),
                    productName: this.searchForm.productName.trim(),
                    roomId: this.searchForm.roomId || '',
                    startTime: this.searchForm.dateTime[0] || '',
                    endTime: this.searchForm.dateTime[1] || ''
                };

                // 调用接口获取全部数据
                const response = await getOutboundPlans(params);
                // 保存原始全部数据（接口返回的原始数据）
                this.allOutboundList = response.data || [];

                // 前端过滤数据（叠加前端搜索条件）
                const filteredList = this.filterData();
                // 更新总条数和当前页数据
                this.total = filteredList.length;
                // 重新赋值过滤后的数据，用于分页
                this.allOutboundList = filteredList;
                // 执行分页
                this.handlePagination();



                // // 兜底：如果无数据，添加测试数据验证分页功能
                // if (this.total === 0) {
                //     this.allOutboundList = Array.from({ length: 50 }).map((_, i) => ({
                //         id: i + 1,
                //         outboundNumber: `OUT${202512000 + i}`,
                //         numId: `FLOW${1000 + i}`,
                //         productName: `测试产品${i + 1}`,
                //         operationNum: 10 + i,
                //         unit: '件',
                //         roomId: (i % 5) + 1,
                //         room: ['热菜间', '凉菜间', '面点间', '包装间', '仓储间'][i % 5],
                //         taskNumber: `TASK${9000 + i}`,
                //         orderNumber: `ORDER${8000 + i}`,
                //         dateTime: `2025-12-${(i % 30) + 1} 10:${i % 60}:${i % 60}`,
                //         operatorName: '测试操作员'
                //     }));
                // 重新过滤测试数据（确保功能间筛选生效）
                //     const testFilteredList = this.filterData();
                //     this.total = testFilteredList.length;
                //     this.allOutboundList = testFilteredList;
                //     this.handlePagination();
                //     console.log('已添加测试数据，总条数：', this.total);
                // }

            } catch (error) {
                console.error('出库计划列表请求异常:', error);
                this.$message.error('网络异常，无法加载出库计划数据');
                this.allOutboundList = [];
                this.outboundList = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },

        /**
         * 重置搜索条件
         */
        resetSearch() {
            this.searchForm = {
                outboundNumber: '',
                numId: '',
                productName: '',
                productCode: '',
                roomId: '',
                dateTime: []
            };
            this.currentPage = 1; // 重置为第一页
            this.fetchOutboundPlans();
        },

        /**
         * 分页大小改变
         */
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1; // 页大小改变，重置为第一页
            this.$nextTick(() => {
                this.handlePagination(); // 重新分页
            });
        },

        /**
         * 当前页码改变
         */
        handleCurrentChange(page) {
            this.currentPage = page;
            this.$nextTick(() => {
                this.handlePagination(); // 重新分页
            });
        },

        /**
         * 查看出库计划详情
         */
        viewDetail(row) {
            console.log(row);
            this.currentOutbound = { ...row }; // 深拷贝避免数据联动
            this.detailVisible = true;
            console.log(this.detailVisible);
        },


    }
};
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>